import { useEffect, useRef } from 'react';
import { GenerationResponse } from '../../services/generationsApi';
import { useStationMode } from '../station';

interface UseStationAutoActionsParams {
  isMusicGenerationSession: boolean;
  song1Ready: boolean;
  activeMusicGeneration?: GenerationResponse;
  handleCardClick: (songVersion: 1 | 2) => void;
  song1SavedId: string | null;
}

export const useStationAutoActions = ({
  isMusicGenerationSession,
  song1Ready,
  activeMusicGeneration,
  handleCardClick,
  song1SavedId,
}: UseStationAutoActionsParams) => {
  const isStationMode = useStationMode();
  const hasAutoPlayedSong1Ref = useRef(false);

  useEffect(() => {
    hasAutoPlayedSong1Ref.current = false;
  }, [activeMusicGeneration?.taskId]);

  useEffect(() => {
    if (
      isStationMode &&
      isMusicGenerationSession &&
      song1Ready &&
      !hasAutoPlayedSong1Ref.current &&
      activeMusicGeneration &&
      !activeMusicGeneration.error &&
      song1SavedId
    ) {
      hasAutoPlayedSong1Ref.current = true;
      handleCardClick(1);
    }
  }, [
    isStationMode,
    isMusicGenerationSession,
    song1Ready,
    activeMusicGeneration,
    handleCardClick,
    song1SavedId,
  ]);
};
